import { render, staticRenderFns } from "./DrivewealthFees.vue?vue&type=template&id=74a7db53"
import script from "./DrivewealthFees.vue?vue&type=script&lang=ts"
export * from "./DrivewealthFees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports